import moment from 'moment'
import { isEmptyValue } from './common'
import { DATE_FORMAT } from '@/constant/date'

export function formatDeliveryDate(time: any) {
  if (isEmptyValue(time)) return ''
  console.log('time', time)
  const times = time.split(',')
  let resultTimes = ''
  if (times.length < 2)
    return time ? moment(time).format('DD  MMM  YYYY') : 'N/A'
  for (const [index, tmpTime] of times.entries()) {
    resultTimes =
      resultTimes +
      `${moment(tmpTime).format('DD  MMM  YYYY')}${
        index != times.length - 1 ? ', ' : ''
      }`
  }
  return resultTimes
}

export function convertUtcToLocal(utcIsoString) {
  if (utcIsoString) {
    const timezone = moment.tz.guess(true)
    var utcCutoff = moment.utc(utcIsoString, 'YYYYMMDD HH:mm:ss')
    var displayCutoff = utcCutoff.clone().tz(timezone).format('DD MMM YYYY')
    return displayCutoff
  }
  return ''
}

/**
 * Returns an object with year, month, and day
 * @param mode optional - 'current_year' | 'last_year' | 'next_year' | '',
 * @param date optional - string or Date. Defaults to today if not provided
 * @returns { year: number, month: number, day: number }
 */
export function getDateObject(
  mode?: 'current_year' | 'last_year' | 'next_year' | '',
  date?: string
): {
  year: number
  month: number
  day: number
} {
  let momentValue = date ? moment(date) : moment()

  if (mode === 'next_year') {
    momentValue = momentValue.clone().add(1, 'year')
  }

  if (mode === 'last_year') {
    momentValue = momentValue.clone().subtract(1, 'year')
  }

  let result = {
    year: momentValue.year(),
    month: momentValue.month() + 1,
    day: momentValue.date(),
  }
  return result
}

export function convertUtcToLocalDateTime(utcIsoString) {
  if (utcIsoString) {
    const timezone = moment.tz.guess(true)
    var utcCutoff = moment.utc(utcIsoString, 'YYYYMMDD HH:mm:ss')
    var displayCutoff = utcCutoff
      .clone()
      .tz(timezone)
      .format('DD MMM YYYY - hh:mm A')
    return displayCutoff
  }
  return ''
}

export function getMostRecentDate(data) {
  return data.reduce((mostRecentDate, object) => {
    const date = new Date(object.last_modified_date)
    return date > mostRecentDate ? date : mostRecentDate
  }, new Date(0))
}

/**
 * Formats a valid date.
 *
 * @param date - Date to format.
 * @param format - Moment.js format. Default: "DD MMM YYYY".
 * @returns Formatted date string, or an empty string if the date is invalid.
 *
 * Result:
 * dateFormat("2026-07-31")                  // "31 Jul 2026"
 * dateFormat("2026-07-31", "YYYY/MM/DD")    // "2026/07/31"
 * dateFormat("invalid-date")                // ""
 * dateFormat("")                            // ""
 */
export function dateFormat(date: string = '', format = DATE_FORMAT.DDMMYY) {
  const isValidFormat = moment(date).isValid()
  if (!isValidFormat) {
    return ''
  }
  return moment(date).format(format)
}
